import { defineStore } from 'pinia';

export const useLayoutStore = defineStore('layout', {
  state: () => ({
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    isRTL: false,
    color: '',
    sidebarType: 'bg-white',
    darkMode: false,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    isLoading: false,
    layout: 'default',
    query: {},
    progress: 0,
    isProgressBar: false,
    keepAlive: []
  }),
  actions: {
    toggleSidebarColor(sidebarType) {
      this.sidebarType = sidebarType;
    },
    toggleDefaultLayout() {
      console.log('toggleDefaultLayout');
      this.showNavbar = !this.showNavbar;
      this.showSidenav = !this.showSidenav;
      this.showFooter = !this.showFooter;
    },
    setLoginDefaultLayout() {
      console.log('setLoginDefaultLayout');
      this.showNavbar = false;
      this.showSidenav = false;
      this.showFooter = false;
    }
  },
  getters: {
    getIsRtl: (state) => state.isRTL,
    getIsNavFixed: (state) => state.isNavFixed,
    getDarkMode: (state) => state.darkMode
  },
  persist: true
});
